import Vue from 'vue'

import App from '@/App'
import router from '@/router'
import store from '@/vuex'

import moment from 'moment'
import 'eq.js'
import 'material-design-lite/material'
import 'mdl-ext'
import 'dialog-polyfill'
import 'mdl-selectfield/dist/mdl-selectfield'

import VueChartist from 'vue-chartist'
import VeeValidate from 'vee-validate'
import ValidationMessagesSV from './sv.js'

Vue.use VeeValidate, 
  locale: 'sv'
  dictionary: 
    sv: 
      messages: ValidationMessagesSV

Vue.use VueChartist, 
  messageNoData: 'You have not enough data'
  classNoData: 'empty'

Vue.config.productionTip = false

router.beforeEach (from, to, next) ->
  console.log store.state.user.is_logged_in, from.path, to.path
  if store.state.user.is_logged_in
    console.log 'going next'
    next()
    return

  if from.path != '/login'
    console.log 'going to login'
    next('/login')
    return

  console.log 'faller igenom'
  next()

new Vue
  el: '#app'
  router: router
  template: '<App/>'
  components: App: App
  store: store



// WEBPACK FOOTER //
// ./src/main.coffee